import { Component, OnInit } from '@angular/core';
import { ApplicationViewsService } from '../ApplicationViews/Services/application-views.services';
import { ViewInfoResource } from 'src/app/client-api.service';
import { map, tap } from 'rxjs/operators';
import { MaintenanceService } from '../services/maintenance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TableButton, TableColumn } from 'src/app/shared/tcc-ui/tables';

@Component({
  selector: 'app-ledger-views',
  templateUrl: './ledger-views.component.html',
  styles: [
  ]
})
export class LedgerViewsComponent implements OnInit {

  viewInfos$ = this.applicationViewsService.viewInfos$;
  viewInfos: ViewInfoResource[] | undefined;

  state: 'initializing' | 'loading' | 'ready' | 'saving';
  buttons: TableButton<any>[] | undefined;
  columns: TableColumn<ViewInfoResource>[] | undefined;
  
  constructor(private applicationViewsService: ApplicationViewsService,
              private maintenanceService: MaintenanceService,
              private activatedRoute: ActivatedRoute,
              private router: Router) { 

    this.state = 'initializing';  
    this.columns = [
      { title: 'viewId', name: 'viewId'},
      { title: 'Name', name: 'name' },
      { title: 'ledgerId', name: 'ledgerId' }     
    ];

    this.buttons = [
      {
        data: 'editViewInfoRecord',
        iconClass: 'fas fa-pencil-alt',
        hidden: false,
        buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
        tooltip: 'Edit View Info Record'
      }
    ];
  }

  ngOnInit(): void {    
    this.maintenanceService.setMaintenanceComponenetPanelSize('small');

    this.viewInfos$.pipe(
      map(v => {
        this.viewInfos = v;        
        return v;
      }),
      tap(() => {this.state = 'ready'})
    ).subscribe();

    this.applicationViewsService.setViewInfos();
    this.applicationViewsService.setApplicationViews();
  }


  rowClicked(event: any) {    
    if (event.button) {
            if (event.button.data === 'editViewInfoRecord') {
        this.maintenanceService.setMaintenanceComponenetPanelSize('large');
        this.router.navigate(['upsert-view-info/', event.row?.viewId], { relativeTo: this.activatedRoute });
      }    
    }
    else {
      this.router.navigate(['viewaccounts/', event.row?.name], { relativeTo: this.activatedRoute });      
    }
  }

  openViewInfoEditPanel(viewId: number) {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');      
    this.router.navigate(['upsert-view-info/', viewId], { relativeTo: this.activatedRoute });
  }
}
